import React from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Button, Input } from '@mui/material';
import { ChangeQuantityModal } from './ChangeQuantityModal';
import { translate } from '../../i18n/customI18nProvider';

export default function ConsumptionCard({ consumption, quantity = 0, onChange = () => {}, allDeposits = [], withoutCard = false }) {
    const { name = 'Article', price = 0, color, deposit = null, type = "quantity", round = 1 } = consumption || {};
    const [ quantityModal, setQuantityModal ] = React.useState({ open: false });;
    const depositInfo = allDeposits.find(d => d._id === deposit) || {};
    const handleAdd = () => {
        onChange(quantity + 1);
    };
    const handleRemove = () => onChange(Math.max(0, quantity - 1));

    const initials = (name || '?').trim().charAt(0).toUpperCase();

    const content = () => (
        <>
            <Avatar sx={{ bgcolor: color || 'primary.main', width: 40, height: 40, fontWeight: 700 }}>{initials}</Avatar>

            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="body2" sx={{ fontWeight: 700 }}>{name}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                    CHF {Number(price || 0).toFixed(2)} {depositInfo.price ? `+ CHF ${Number(depositInfo.price).toFixed(2)} ${translate('custom.of_deposit')}` : ''}
                </Typography>
            </Box>

            {type === 'input' ?
                <Button sx={{ color: 'black', width: '100px' }} variant='outlined' onClick={() => setQuantityModal({ open: true })}>
                    {quantity}
                </Button>
                :
                <Box sx={{ textAlign: 'right', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                        <IconButton size="small" onClick={handleRemove} sx={{ margin: 0, background: '#628bd0ff', color: 'white', '&:hover': { background: '#4971c1' }}} aria-label={`${translate('custom.remove')} ${name}`}>
                            <RemoveIcon size="small" />
                        </IconButton>

                        <Typography sx={{ minWidth: 20, textAlign: 'center', fontWeight: 700 }}>{quantity}</Typography>
                        
                        <IconButton size="small" onClick={handleAdd} sx={{ margin: 0, background: '#628bd0ff', color: 'white', '&:hover': { background: '#4971c1' } }} aria-label={`${translate('custom.add')} ${name}`}>
                            <AddIcon size="small" />
                        </IconButton>
                    </Box>
                </Box>
            }
        </>
    )

    return (
        <>
            {withoutCard ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, padding: 0 }}>
                        {content()}
                    </Box>
                ) : (
                    <Card variant="outlined" sx={{ borderRadius: 2, boxShadow: 1, flexShrink: 0 }}>
                        <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, padding: 2 }}>
                            {content()}
                        </CardContent>
                    </Card>
                )
            }
            <ChangeQuantityModal
                quantity={quantity}
                round={round}
                open={quantityModal.open}
                onClose={() => {setQuantityModal({ open: false, })}}
                onConfirm={(quantity) => {setQuantityModal({ open: false}); onChange(quantity)}}
            />
        </>
    );
}

ConsumptionCard.propTypes = {
    consumption: PropTypes.shape({
        name: PropTypes.string,
        price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        color: PropTypes.string,
        min_age: PropTypes.number,
    }).isRequired,
    quantity: PropTypes.number,
    onChange: PropTypes.func,
    userAge: PropTypes.number,
};